import { SchoolDto, State } from "../../interfaces";
import { Paginated } from "../../models";
import {
  ADD_SCHOOL,
  ADD_SCHOOL_ERROR,
  ADD_SCHOOL_SUCCESS,
  ActionTypes,
  DELETE_SCHOOL,
  DELETE_SCHOOL_CONSENT,
  DELETE_SCHOOL_ERROR,
  DELETE_SCHOOL_SUCCESS,
  GET_SCHOOL,
  GET_SCHOOLS,
  GET_SCHOOLS_ERROR,
  GET_SCHOOLS_SUCCESS,
  GET_SCHOOL_ERROR,
  GET_SCHOOL_SELECT_LIST,
  GET_SCHOOL_SELECT_LIST_ERROR,
  GET_SCHOOL_SELECT_LIST_SUCCESS,
  GET_SCHOOL_SUCCESS,
  RESET_SCHOOL_SELECT_LIST,
  UPDATE_SCHOOL,
  UPDATE_SCHOOL_ERROR,
  UPDATE_SCHOOL_SUCCESS,
} from "./actionTypes";

export class SchoolState {
  schools!: State<Paginated<SchoolDto>>;
  school!: State<SchoolDto>;
  schoolSelectList!: State<SchoolDto>;
  addSchool!: State<any>;
  updateSchool!: State<any>;
  deleteSchool!: State<any>;
  constructor() {
    this.schools = {
      loading: false,
      error: null,
      success: false,
    };
    this.school = {
      loading: false,
      error: null,
      success: false,
    };
    this.schoolSelectList = {
      loading: false,
      error: null,
      success: false,
    };
    this.addSchool = {
      loading: false,
      error: null,
      success: false,
    };
    this.updateSchool = {
      loading: false,
      error: null,
      success: false,
    };
    this.deleteSchool = {
      loading: false,
      error: null,
      success: false,
    };
  }
}

const initialState: SchoolState = new SchoolState();

export const school = (
  state: SchoolState = initialState,
  action: ActionTypes
) => {
  switch (action.type) {
    case GET_SCHOOLS:
      state = {
        ...state,
        schools: {
          ...state.schools,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SCHOOLS_SUCCESS:
      state = {
        ...state,
        schools: {
          ...state.schools,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SCHOOLS_ERROR:
      state = {
        ...state,
        schools: {
          ...state.schools,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_SCHOOL:
      state = {
        ...state,
        school: {
          ...state.school,
          loading: true,
          success: false,
          error: null,
        },
        addSchool: {
          ...state.addSchool,
          loading: false,
          success: false,
          error: null,
        },
        updateSchool: {
          ...state.updateSchool,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SCHOOL_SUCCESS:
      state = {
        ...state,
        school: {
          ...state.school,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SCHOOL_ERROR:
      state = {
        ...state,
        school: {
          ...state.school,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case GET_SCHOOL_SELECT_LIST:
      state = {
        ...state,
        schoolSelectList: {
          ...state.schoolSelectList,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case GET_SCHOOL_SELECT_LIST_SUCCESS:
      state = {
        ...state,
        schoolSelectList: {
          ...state.schoolSelectList,
          loading: false,
          error: null,
          success: true,
          response: action.payload,
        },
      };
      break;
    case GET_SCHOOL_SELECT_LIST_ERROR:
      state = {
        ...state,
        schoolSelectList: {
          ...state.schoolSelectList,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case RESET_SCHOOL_SELECT_LIST:
      state = {
        ...state,
        schoolSelectList: {
          ...state.schoolSelectList,
          loading: false,
          success: false,
          error: action.payload,
          response: undefined,
        },
      };
      break;
    case ADD_SCHOOL:
      state = {
        ...state,
        addSchool: {
          ...state.addSchool,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case ADD_SCHOOL_SUCCESS:
      state = {
        ...state,
        addSchool: {
          ...state.addSchool,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case ADD_SCHOOL_ERROR:
      state = {
        ...state,
        addSchool: {
          ...state.addSchool,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;

    case UPDATE_SCHOOL:
      state = {
        ...state,
        updateSchool: {
          ...state.updateSchool,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case UPDATE_SCHOOL_SUCCESS:
      state = {
        ...state,
        updateSchool: {
          ...state.updateSchool,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case UPDATE_SCHOOL_ERROR:
      state = {
        ...state,
        updateSchool: {
          ...state.updateSchool,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    case DELETE_SCHOOL_CONSENT:
      state = {
        ...state,
        deleteSchool: {
          ...state.deleteSchool,
          loading: false,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_SCHOOL:
      state = {
        ...state,
        deleteSchool: {
          ...state.deleteSchool,
          loading: true,
          success: false,
          error: null,
        },
      };
      break;
    case DELETE_SCHOOL_SUCCESS:
      state = {
        ...state,
        deleteSchool: {
          ...state.deleteSchool,
          loading: false,
          error: null,
          success: true,
        },
      };
      break;
    case DELETE_SCHOOL_ERROR:
      state = {
        ...state,
        deleteSchool: {
          ...state.deleteSchool,
          loading: false,
          success: false,
          error: action.payload,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
